import { ControlledSwitch } from "@hm/fundamental"

import type { ViewMode } from "../types"

interface ContentSwitchProps {
	viewMode: ViewMode
	onSetViewMode: (mode: ViewMode) => void
	monthsTabLabel: string
	daysTabLabel: string
	"data-cy": string
}

export const ContentSwitch: React.FC<ContentSwitchProps> = ({
	viewMode,
	onSetViewMode,
	monthsTabLabel,
	daysTabLabel,
	"data-cy": dataCy,
}) => {
	return (
		<div className="mb-4">
			<ControlledSwitch
				value={viewMode}
				options={[
					{ label: monthsTabLabel, value: "months" },
					{ label: daysTabLabel, value: "days" },
				]}
				onChange={val => onSetViewMode(val as ViewMode)}
				data-cy={`${dataCy}-content-switch`}
			/>
		</div>
	)
}
